import { isEmpty } from 'lodash';

const getAllEcommerceResponse = (response) => {
  if (isEmpty(response?.data?.ecommerces)) return [];

  return response?.data?.ecommerces.map((ecommerce) => {
    return {
      id: ecommerce?.id,
      value: ecommerce?.id,
      label: ecommerce?.name,
    };
  });
};

export default getAllEcommerceResponse;
